export const RECORD_LOAD = "record/on_load";
export const recordLoad = () => ({
  type: RECORD_LOAD,
});

export const RECORD_LOAD_SUCCESS = "record/on_load_success";
export const recordLoadSuccess = (data, recordData) => ({
  type: RECORD_LOAD_SUCCESS,
  payload: {
    plan: data,
    recordData: recordData
  }
});

export const RECORDED_DELETE = "record/delete_recorded";
export const recordedDelete = (data) => ({
  type: RECORDED_DELETE,
  payload: data
});

export const RECORDED_ADD = "record/add_recorded";
export const recordedAdd = (data, url) => ({
  type: RECORDED_ADD,
  payload: data,
  url: url
});

export const RECORDED_REMOVE = "record/remove_recorded";
export const recordedRemove = (data, url) => ({
  type: RECORDED_REMOVE,
  payload: data,
  url: url
});

export const RECORD_ACTION_SUCCESS = "record/action_success";
export const recordActionSuccess = (data) => ({
  type: RECORD_ACTION_SUCCESS,
  payload: data
});
